<template>
  <div class="add-video-modal">
    <el-dialog :show-close="false" title="上传视频" :close-on-click-modal="false" top="2vh" :visible.sync="dialogVisible" width="700px">
      <el-form :rules="rules" :model="ruleForm" ref="ruleForm" label-width="90px">
        <el-form-item prop="userId" label="用户：">
          <el-select style="width: 290px" filterable v-model="ruleForm.userId" placeholder="请选择用户" @change="changeUser">
            <el-option v-for="item in userList" :key="item.clientId" :label="item.youtubeUserName" :value="item.clientId">
              {{ item.youtubeUserName }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="channelId" label="频道：">
          <el-select style="width: 290px" filterable v-model="ruleForm.channelId" placeholder="请选择频道" @change="changeChannel">
            <el-option v-for="item in channelList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="upload" label="" class="upload">
          <el-upload
            v-loading="uploadLoading"
            class="upload-item"
            drag
            :action="actionUrl"
            :on-change="uploadVideoFiles"
            :on-exceed="onExceed"
            :auto-upload="false"
            multiple
            ref="upload"
            :show-file-list="false"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              <div>将文件拖到此处，或<em>点击上传</em></div>
              <div>大小：不超过1000M</div>
              <div>格式：mp4/3gp/mpeg/avi/mov</div>
            </div>
          </el-upload>
          <el-table
            :border="false"
            :data="ruleForm.tableData.slice((pageData.page - 1) * pageData.size, pageData.page * pageData.size)"
            style="width: 100%; margin-top: 12px"
          >
            <el-table-column prop="thumbnailUrl" label="缩略图" width="90">
              <template slot-scope="scope"> <img :src="scope.row.thumbnailUrl" style="max-height: 40px; max-width: 80px" /> </template>
            </el-table-column>
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="title" label="标题" width="260">
              <template slot-scope="scope">
                <el-input v-model="scope.row.title"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="operate" label="操作" width="90">
              <template slot-scope="scope">
                <el-button type="text" @click="deleteVideo(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <self-pagination
            :total="ruleForm.tableData.length"
            :pageSize="pageData.size"
            :currentPage="pageData.page"
            ref="tabelPagination"
            @getCurrentPage="changePage"
            @handleSizeChange="changePageSize"
          ></self-pagination>
        </el-form-item>
        <el-form-item prop="madeForKid" label="观众：">
          <el-radio-group v-model="ruleForm.madeForKid">
            <el-radio :label="1">内容是面向儿童</el-radio>
            <el-radio :label="0">内容不是面向儿童</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="categoryId" label="类别：">
          <el-select style="width: 290px" filterable v-model="ruleForm.categoryId" placeholder="请选择类别">
            <el-option v-for="item in categoryList" :key="item.id" :label="item.categoryName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="playlistId" label="播放列表：">
          <el-select
            style="width: 290px"
            popper-class="youtube-upload-video-list"
            v-model="ruleForm.playlistId"
            placeholder="请选择播放列表"
            filterable
          >
            <el-option style="margin-bottom: 8px" v-for="item in videoList" :key="item.id" :value="item.id" :label="item.playName">
            </el-option>
          </el-select>
          <el-button type="text" style="margin-left: 12px" @click="refreshVideoList">刷新播放列表 </el-button>
          <el-button type="text" style="margin-left: 12px" @click="addVideoList">创建播放列表 </el-button>
        </el-form-item>
        <el-form-item prop="publishScope" label="公开范围：">
          <el-radio-group v-model="ruleForm.publishScope" size="small" style="display: block">
            <el-radio-button label="publish">保存或发布</el-radio-button>
            <el-radio-button label="delay">安排时间</el-radio-button>
          </el-radio-group>
          <el-radio-group v-model="ruleForm.privacyStatus" v-if="ruleForm.publishScope === 'publish'">
            <el-radio label="private">私享</el-radio>
            <el-radio label="unlisted">不公开列出</el-radio>
            <el-radio label="public">公开</el-radio>
          </el-radio-group>
          <el-date-picker :picker-options="pickerOptions" v-else v-model="ruleForm.publishAt" type="datetime" placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="description" label="说明：">
          <el-input
            type="textarea"
            style="width: 420px"
            :autosize="{ minRows: 4, maxRows: 6 }"
            placeholder="请输入说明"
            v-model="ruleForm.description"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="loading" @click="handleConfirm">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog :show-close="false" title="创建播放列表" :close-on-click-modal="false" :visible.sync="addVideoModalVisible" width="500px">
      <el-form :rules="rules" :model="videoListForm" ref="videoListForm" label-width="90px">
        <el-form-item prop="videoListTitle" label="标题：">
          <el-input
            type="text"
            style="width: 320px"
            maxlength="150"
            show-word-limit
            placeholder="请输入标题"
            v-model="videoListForm.videoListTitle"
          ></el-input>
        </el-form-item>
        <el-form-item prop="privacyStatus" label="公开范围：">
          <el-radio-group v-model="videoListForm.privacyStatus">
            <el-radio label="private">私享</el-radio>
            <el-radio label="unlisted">不公开列出</el-radio>
            <el-radio label="public">公开</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelAddVideo">取消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="confirmAddVideo">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getVideoCategories, getPlaylists, getChannelList, savePlayList, addYoutubeFiles, getYoutubeUserPermList } from "@/api/property.js";
import moment from "moment";
export default {
  data() {
    return {
      dialogVisible: false,
      addVideoModalVisible: false,
      ruleForm: {},
      videoListForm: {
        videoListTitle: "",
        privacyStatus: "private",
      },
      actionUrl: `${process.env.VUE_APP_BASE_URL}/${process.env.VUE_APP_CONTENT_PATH}/youtube/newFiles`,
      channelList: [],
      categoryList: [],
      videoList: [],
      userList: [],
      rules: {
        userId: [{ required: true, message: "请选择用户", trigger: "change" }],
        channelId: [{ required: true, message: "请选择频道", trigger: "change" }],
        categoryId: [{ required: true, message: "请选择类别", trigger: "change" }],
        playlistId: [{ required: true, message: "请选择播放列表", trigger: "change" }],
        // description: [{ required: true, message: "请输入说明", trigger: "change" }],
        upload: [
          {
            validator: (rule, value, callback) => {
              const index = this.ruleForm.tableData.findIndex((item) => !item.title);
              if (this.ruleForm.tableData.length === 0) {
                callback(new Error("请上传视频"));
              } else if (index > -1) {
                callback(new Error(`上传的第${index + 1}个视频的标题不能为空`));
              } else {
                callback();
              }
            },
            trigger: ["change"],
          },
        ],
        publishScope: [
          {
            validator: (rule, value, callback) => {
              if (this.ruleForm.publishScope === "delay" && !this.ruleForm.publishAt) {
                callback(new Error("请选择公开范围的日期时间"));
              } else {
                callback();
              }
            },
            trigger: ["change"],
          },
        ],
        videoListTitle: [{ required: true, message: "请输入标题", trigger: "change" }],
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一月前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      uploadLoading: false,
      loading: false,
      pageData: {
        size: 10,
        page: 1,
      },
      modalType: "",
      btnLoading: false,
    };
  },
  methods: {
    openModal() {
      this.ruleForm = {
        userId: "",
        channelId: "",
        tableData: [],
        madeForKid: 1,
        categoryId: "",
        playlistId: "",
        publishScope: "publish",
        publishAt: "",
        privacyStatus: "private",
        description: "",
      };
      this.initSelect();
      this.dialogVisible = true;
      this.loading = false;
      this.$refs.ruleForm?.clearValidate();
    },
    initSelect() {
      getYoutubeUserPermList().then((res) => {
        this.userList = res.data;
      });
    },
    changeUser() {
      this.ruleForm.channelId = "";
      this.ruleForm.categoryId = "";
      this.ruleForm.playlistId = "";
      getChannelList({
        userId: this.ruleForm.userId,
        userName: this.userList.find((item) => item.clientId === this.ruleForm.userId).youtubeUserName,
      })
        .then((res) => {
          this.channelList = res.data;
        })
        .catch(() => {
          this.channelList = [];
        });
      getVideoCategories({
        userId: this.ruleForm.userId,
      }).then((res) => {
        this.categoryList = res.data;
      });
      this.getVideoList();
    },
    changeChannel() {
      this.ruleForm.playlistId = "";
      this.getVideoList();
    },
    getVideoList() {
      getPlaylists({
        userId: this.ruleForm.userId,
        channelId: this.ruleForm.channelId,
      }).then((res) => {
        this.videoList = res.data;
      });
    },
    handleConfirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          const { userId, categoryId, channelId, description, tableData, madeForKid, playlistId, privacyStatus, publishAt, publishScope } =
            this.ruleForm;
          addYoutubeFiles({
            userId,
            categoryId,
            channelId,
            description,
            fileInfoList: tableData.map((item) => {
              return {
                title: item.title,
                url: item.thumbnailUrl,
                uuid: item.uuid,
              };
            }),
            madeForKid,
            playlistId,
            playName: this.videoList.find((item) => item.id === playlistId).playName,
            privacyStatus,
            publishAt: publishAt ? moment(publishAt).format("YYYY-MM-DD HH:mm:ss") : "",
            publishScope,
          })
            .then((res) => {
              this.loading = false;
              if (res.code === "0000") {
                this.dialogVisible = false;
                this.$emit("successCallBack");
                this.$message.success("上传成功");
              }
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          // this.$message.error("表单未填写完成");
          return false;
        }
      });
    },
    addVideoList() {
      if (!this.ruleForm.userId || !this.ruleForm.channelId) {
        this.$message.warning("请先选择用户和渠道");
      } else {
        this.dialogVisible = false;
        this.addVideoModalVisible = true;
      }
    },
    refreshVideoList() {
      if (!this.ruleForm.userId) {
        this.$message.warning("请先选择用户和渠道");
        return;
      }
      getPlaylists({
        userId: this.ruleForm.userId,
        channelId: this.ruleForm.channelId,
      }).then((res) => {
        if (res.code === "0000") {
          this.videoList = res.data;
          this.$message.success("刷新成功");
        }
      });
    },
    cancelAddVideo() {
      this.dialogVisible = true;
      this.addVideoModalVisible = false;
    },
    confirmAddVideo() {
      this.$refs.videoListForm.validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          const { privacyStatus, videoListTitle } = this.videoListForm;
          savePlayList({
            privacyStatus,
            title: videoListTitle,
            userId: this.ruleForm.userId,
            channelId: this.ruleForm.channelId,
          })
            .then((res) => {
              this.btnLoading = false;
              if (res.code === "0000") {
                this.getVideoList();
                this.dialogVisible = true;
                this.addVideoModalVisible = false;
                this.$message.success("创建成功");
              }
            })
            .catch(() => {
              this.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
    changePage(page) {
      this.pageData.page = page;
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
    },
    deleteVideo(row) {
      this.$confirm("确定删除该视频?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const index = this.ruleForm.tableData.findIndex((item) => item.id == row.id);
          this.ruleForm.tableData.splice(index, 1);
          this.pageData.page = 1;
        })
        .catch(() => {});
    },
    //文件校验方法
    beforeVideoUpload(file) {
      let fileArr = file.name.split(".");
      let suffix = fileArr[fileArr.length - 1];
      if (!["mp4", "3gp", "mpeg", "avi", "mov"].includes(suffix)) {
        this.$message.warning("视频格式只能是mp4，3gp，mpeg，avi，mov格式!");
        return;
      }
      //不能导入大小超过1000Mb的视频
      if (file.size > 1000 * 1024 * 1024) {
        this.$message("文件过大，请上传小于1000MB的文件〜");
        return false;
      }
      return true;
    },
    onExceed() {
      this.$refs.upload.clearFiles();
    },
    uploadVideoFiles(file) {
      //判断是否符合beforeVideoUpload方法中的条件
      if (this.beforeVideoUpload(file)) {
        const fileFormData = new FormData();
        fileFormData.append("file", file.raw, file.name);
        this.uploadLoading = true;
        this.$store.dispatch("uploadFile", {
          param: fileFormData,
          cb: (data) => {
            this.uploadLoading = false;
            if (data.code == "0000") {
              this.$notify({
                title: "提示",
                message: "上传成功",
                type: "success",
              });
              const index = this.ruleForm.tableData.findIndex((item) => item.md5 == data.data.md5);
              if (index > -1) {
                this.$set(this.ruleForm.tableData[index], "title", data.data.name.split(".")[0]);
              } else {
                data.data.title = data.data.name.split(".")[0];
                this.ruleForm.tableData.push(data.data);
              }
              this.$refs.upload.clearFiles();
            }
          },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.add-video-modal {
  .upload {
    /deep/ .el-form-item__content {
      margin-left: 0px !important;
    }
  }
  .upload-item {
    width: 100%;
    height: 220px;
    /deep/ .el-upload {
      width: 100%;
      height: 100%;
      background: #f4f6f5;
    }
    /deep/ .el-upload-dragger {
      width: 100%;
      height: 100%;
      background: #f4f6f5;
    }
  }
}
</style>
<style lang="less">
// .youtube-upload-video-list {
//   .el-scrollbar {
//     display: block !important;
//   }
// }
</style>
